import {
  IncidentType,
  AuthorizationFailedReason
} from "@moderrotech/servers-communication-library/src/types";

export const fr = {
  topics: {
    headerTitle: "Sujets",
    search: "Recherche",
    noTopics: "Aucun sujet trouvé",
    notFound: "Aucun sujet correspondant au modèle trouvé",
    schedule: {
      closed: "Nous sommes fermés"
    },
    customerInfoForm: {
      title: "Avant de commencer votre appel vidéo...",
      description:
        "Avant d'utiliser la vidéo banking pour solliciter votre prêt, veuillez remplir le formulaire",
      optional: "Facultatif",
      buttons: {
        cancel: "Annuler",
        submit: "Démarrer un appel vidéo"
      }
    }
  },
  call: {
    calling: "Appel...",
    joining: "Rejoindre l'appel",
    transferring: "Transférer l'appel",
    aspectRatio: "Zoom",
    cancel: "Annuler l'appel",
    end: "Terminer l'appel",
    share: "Appel à plusieurs",
    document: "Document",
    actions: "Actes",
    closeActions: "Annuler",
    mute: "Muette",
    unmute: "Mécontentement",
    textMessage: "Message texte",
    queuePosition: (ctx: { list: Function }) => {
      const position = ctx.list(0);
      const isPositionAvailable = ctx.list(1);
      return `Vous êtes ${
        isPositionAvailable ? `#${position} ` : ""
      } dans la file d'attente`;
    },
    ticket: "Billet",
    camera: {
      enable: "Activer la caméra",
      disable: "Désactiver la caméra"
    },
    hangupRequest: {
      title: "Es-tu sûr?",
      body: "Voulez-vous vraiment vous déconnecter ?",
      yes: "Oui, raccroche",
      no: "Non, reste de garde"
    },
    downloadFileRequest: {
      title: "L'agent a partagé un fichier avec vous",
      yes: "Télécharger",
      no: "Rejeter"
    },
    openUrlRequest: {
      title: "Ouvrir l'URL",
      body: "L'agent souhaite ouvrir une URL dans un nouvel onglet",
      yes: "Ouvrir l'URL",
      no: "Annuler"
    },
    lowPerformanceNotification: {
      title:
        "Il semble que votre appareil ait de faibles performances. S'il vous plaît, n'utilisez pas l'appareil photo pour éviter le crash de l'application",
      gotIt: "J'ai compris"
    },
    signaturePad: {
      submit: "Soumettre",
      clear: "Clair",
      cancel: "Annuler"
    },
    paintover: {
      submit: "Soumettre",
      clear: "Clair",
      cancel: "Annuler"
    },
    textMessageForm: {
      placeholder: "Message"
    },
    recordTranslator: {
      transcribing: "Parle, s'il te plaît"
    },
    cameraSnapshot: {
      title: "Instantané de la caméra"
    },
    mediaInputsAccessNote: {
      title: "Veuillez autoriser l'accès au microphone et à la caméra",
      description:
        "Recherchez une petite fenêtre contextuelle près de la barre d'adresse de votre navigateur."
    },
    animatedCharacter: {
      listening: {
        title: "L'agent est à l'écoute",
        description: "Vous pouvez parler. Posez votre question ou demande."
      },
      thinking: {
        title: "L'agent réfléchit",
        description:
          "Veuillez patienter pendant que l'agent cherche une réponse."
      }
    },
    success: {
      document: "Le document a été envoyé avec succès.",
      feedback: "Un feedback a été envoyé",
      textMessage: "Le SMS a été envoyé",
      signaturePad: "La signature a été envoyée",
      paintover: "L'image a été envoyée",
      textCopy: "Le texte a été copié dans le presse-papier",
      imageCopy: "L'image a été copiée dans le presse-papiers",
      callSharing: "Le lien a été copié dans le presse-papier"
    },
    error: {
      base: "Quelque chose s'est mal passé. S'il vous plaît, rechargez la page",
      mediaInputsAccess:
        "Impossible d'accéder au microphone et/ou à la caméra. Veuillez les activer dans les paramètres",
      join: "Impossible de participer à l'appel",
      document: "Impossible d'envoyer le document",
      noExperts: "Aucun agent disponible",
      noTopic: "Le sujet n'est plus disponible",
      queueSuspended:
        "File d'attente suspendue<br>Nous ne sommes pas en mesure de prendre de nouveaux appels pour le moment. Veuillez réessayer plus tard.",
      queueOverloaded:
        "File d'attente surchargée<br>Nous recevons un volume d'appels élevé. Veuillez réessayer plus tard.",
      timeout: "Attendre un agent trop longtemps",
      documentSize: "Le document est trop volumineux",
      feedback: "Quelque chose s'est mal passé",
      noRoom: "Le rendez-vous est expiré ou a été annulé par le médecin",
      textMessage: "Le message texte ne peut pas être envoyé",
      signaturePad: "La signature ne peut pas être envoyée",
      paintover: "L'erreur d'envoi d'image",
      textCopy: "Impossible de copier le texte",
      imageCopy: "Impossible de copier l'image",
      callSharing: "Impossible de partager le lien",
      recordTranslation: {
        play: "Impossible de lire l'audio de la traduction",
        streamGetting: "Impossible d'obtenir le flux audio",
        transcription: "Impossible de transcrire le dossier",
        translation: "Impossible de traduire l'enregistrement",
        unsupportedLanguage:
          "Sélection non prise en charge pour VOTRE langue de traduction audio. Mais l'audio de l'agent peut être traduit dans cette langue"
      },
      geolocation: "Impossible d'obtenir la géolocalisation",
      cameraSnapshot: "Impossible de prendre un instantané de l'appareil photo"
    },
    onHold: {
      title: "En attente.",
      description: "L'agent vous répondra sous peu."
    },
    remoteActionRequest: {
      shareFile: {
        title:
          "L'agent souhaite partager un fichier depuis votre appareil. Permettre?",
        yes: "Oui",
        no: "Non"
      },
      screenSharing: {
        title: "L'agent veut voir votre écran. Permettre?",
        yes: "Oui",
        no: "Non"
      }
    },
    settings: {
      title: "Paramètres",
      labels: {
        camera: "Caméra",
        microphone: "Microphone"
      }
    }
  },
  thank: {
    toTopics: "Retour aux sujets",
    redirect: "Prendre rendez-vous"
  },
  ticket: {
    creationRequest: {
      title: (ctx: { list: Function }) => {
        const incidentType = ctx.list(0);
        return incidentType === IncidentType.queueTimeout
          ? "Délai dépassé."
          : "Aucun agent disponible.";
      },
      body: "Vous souhaitez leur laisser un message ?",
      yes: "Oui",
      no: "Non"
    },
    form: {
      labels: {
        phone: "Téléphone",
        email: "E-mail",
        message: "Message"
      },
      buttons: {
        cancel: "Annuler",
        submit: "Envoyer un message"
      }
    }
  },
  feedback: {
    form: {
      fields: {
        email: {
          label: "Depuis:",
          validation: {
            label: "e-mail"
          }
        },
        message: {
          label: "message",
          placeholder: "Message",
          validation: {
            label: "message"
          }
        }
      },
      buttons: {
        submit: "Envoyer",
        cancel: "Annuler",
        open: "Ajouter un message de commentaires..."
      },
      notifications: {
        success: "Le rapport de bug a été envoyé"
      }
    }
  },
  error: {
    connection: {
      title: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "L'agent reste avec vous et vous parlera dans un instant."
          : "Service temporairement indisponible";
      },
      description: (ctx: { list: Function }) => {
        const isOnCall = ctx.list(0);
        return isOnCall
          ? "Nous sommes sur le point de rétablir votre connexion."
          : "La connexion a été perdue. Reconnexion...";
      },
      code: "code: 503"
    },
    login: {
      credentials: "Nom d'utilisateur ou mot de passe incorrect",
      default: "Quelque chose s'est mal passé"
    },
    unpublished: {
      title: "L'application n'existe pas.",
      description:
        "Il peut avoir été temporairement non publié ou supprimé définitivement.",
      code: "code: 404"
    },
    authorization: {
      title: "Accès formellement interdit",
      description: (ctx: { list: Function }) => {
        const reason = ctx.list(0) as
          | AuthorizationFailedReason.geofencingFailed
          | AuthorizationFailedReason.noLicense
          | AuthorizationFailedReason.remStopped
          | AuthorizationFailedReason.noPtpcResponse;
        return {
          [AuthorizationFailedReason.geofencingFailed]:
            "L'application n'est pas disponible dans votre pays ou région.",
          [AuthorizationFailedReason.noLicense]: "Aucune licence attribuée.",
          [AuthorizationFailedReason.remStopped]: "Service non disponible.",
          [AuthorizationFailedReason.noPtpcResponse]:
            "Aucune réponse du serveur."
        }[reason];
      },
      code: "code: 403"
    },
    network: {
      title: "Veuillez vous assurer que vous avez accès à Internet"
    }
  },
  validation: {
    phone: "Le champ {field} doit être un numéro de téléphone valide",
    dni: "Mauvais identifiant, format invalide",
    nie: "Mauvais identifiant, format invalide"
  }
};
